import type { TypeToken } from "../di";

export interface HitlResumeTokenSignerSeam {
  sign(args: { taskId: string; expiresAt: Date; schemaHash: string }): string;
  hashToken(token: string): string;
}

export interface HitlTimeoutJobSchedulerSeam {
  enqueueTimeoutJob(args: { taskId: string; expiresAt: Date }): Promise<void>;
}

export const HitlResumeTokenSignerToken = Symbol.for("codemation.core.HitlResumeTokenSigner") as TypeToken<
  HitlResumeTokenSignerSeam | undefined
>;

export const HitlTimeoutJobSchedulerToken = Symbol.for("codemation.core.HitlTimeoutJobScheduler") as TypeToken<
  HitlTimeoutJobSchedulerSeam | undefined
>;

export const HitlWorkspaceIdToken = Symbol.for("codemation.core.HitlWorkspaceId") as TypeToken<string | undefined>;
